module.exports = __webpack_public_path__ + "static/media/User_Icon_5.a2d679cb.svg";